export default "__VITE_PUBLIC_ASSET__2c5fd0fd__"